<script lang="ts" setup>
import NotFound from '@/views/NotFound';
import { useAppStore } from '@/store/app';
import Main from './Main';
import usePortfolio from './usePortfolio';
import { computed, provide } from 'vue';
import NetWorth from './components/NetWorth.vue';
import WalletFilter from './components/WalletFilter.vue';
import Title from './components/Title.vue';
import Graph from './components/Graph';
import JupHolding from './Main/components/JupHolding';
import ShareBadge from './components/ShareBadge.vue';
import PortfolioSaveBtn from './components/PortfolioSaveBtn.vue';

const appStore = useAppStore();

const portfolioData = usePortfolio();
provide('portfolioData', portfolioData);
const { portfolioInfo, isValid, isInitialized, addressesInfo, isLoading } =
  portfolioData;

const showFilters = computed(() => {
  return (
    addressesInfo.length > 1 ||
    portfolioInfo.elementsByNetworkId.value.length > 1
  );
});
</script>

<template>
  <v-container v-if="!isValid && isInitialized">
    <NotFound></NotFound>
  </v-container>
  <div v-else>
    <v-progress-linear
      color="primary"
      :indeterminate="isLoading"
    ></v-progress-linear>
    <v-container class="pb-0 flex flex-col gap-4">
      <!-- Header -->
      <div
        class="flex flex-col sm:flex-row sm:justify-between sm:align-center gap-2 sm:items-center"
      >
        <Title />
        <WalletFilter />
        <div v-if="addressesInfo.length === 1">
          <PortfolioSaveBtn
            :address="addressesInfo.at(0)!.address"
          ></PortfolioSaveBtn>
        </div>
        <!-- <ShareBadge /> -->
      </div>

      <div class="flex flex-row gap-2" v-if="showFilters">
        <!-- @disabled-jup -->
        <!-- <ChainFilter /> -->
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-12 gap-2">
        <div
          class="flex-1 rounded-jup items-center flex bg-gradient-to-tr bg-surface sm:col-span-4"
        >
          <NetWorth />
        </div>
        <div
          class="bg-surface flex-1 rounded-jup row-span-2 items-center justify-center flex sm:col-span-8"
        >
          <Graph />
        </div>
        <div
          class="flex-1 rounded-jup flex bg-gradient-to-tr bg-surface p-8 flex-col justify-center sm:col-span-4"
        >
          <JupHolding />
        </div>
      </div>

      <!-- @disabled-jup
      <v-tabs color="primary" v-model="appStore.portfolioTab">
        <v-tab
          v-for="item in items"
          :key="item.value"
          :value="item.value"
          class="rounded-t-lg"
        >
          {{ item.title }}
          <div v-if="item.value === 'points'">
            <v-icon
              style="vertical-align: super"
              icon="mdi-creation"
              size="small"
            ></v-icon>
          </div>
        </v-tab>
      </v-tabs> -->
    </v-container>

    <v-container class="pb-12">
      <v-window v-model="appStore.portfolioTab" disabled>
        <v-window-item
          value="portfolio"
          transition="false"
          reverse-transition="false"
        >
          <Main />
        </v-window-item>
        <!-- @disabled-jup -->
        <!-- <v-window-item
          value="nfts"
          transition="false"
          reverse-transition="false"
        >
          <Nfts
            :asset-collectibles="portfolioInfo.assetCollectibles.value"
            :is-loading="isLoading || !isInitialized"
          ></Nfts>
        </v-window-item>
        <v-window-item
          value="points"
          transition="false"
          reverse-transition="false"
        >
          <Points :addresses-info="addressesInfo"></Points>
        </v-window-item>-->
      </v-window>
    </v-container>
  </div>
</template>
